import { Route } from '@greenkub-fronts/shared/router';
import {
  DocumentSignatureContainerFeature,
} from '../feature/document-signature-container-feature/document-signature-container-feature';
import SignatureSuccessFeature
  from '../feature/signature-success-feature/signature-success-feature';

export const PUBLIC_ROUTER_SIGNATURES: Route[] = [
  // SIGNATURE DE DOCUMENT EXISTANT (PDF)
  {
    path: ':projectToken/document/:documentId',
    component: (
      <DocumentSignatureContainerFeature
        isSignature={true}
        fromExisting={true}
        toGenerate={false}
      />
    ),
  },
  // SIGNATURE DE DOCUMENT A GENERER (HTML)
  {
    path: ':projectToken/:documentSlug',
    component: (
      <DocumentSignatureContainerFeature
        isSignature={true}
        toGenerate={true}
        fromExisting={false}
      />
    ),
  },
  // SIGNATURE D'UPSELL
  {
    path: ':projectToken/:documentSlug/:upsellToken',
    component: (
      <DocumentSignatureContainerFeature
        isSignature={true}
        toGenerate={true}
        fromExisting={false}
      />
    ),
  },
  // PAGE DE RESULTAT DE SIGNATURE DE TOUT DOCUMENT CONFONDU
  {
    path: 'success/:projectToken/:documentId',
    component: <SignatureSuccessFeature />,
  },
];

export const PRIVATE_ROUTER_SIGNATURES: Route[] = [
  // PRE SIGNATURE POUR DOCUMENT EXISTANT
  {
    path: ':projectId/document/:documentId',
    component: (
      <DocumentSignatureContainerFeature
        fromExisting={true}
        isSignature={false}
        toGenerate={false}
      />
    ),
  },
  // PRE SIGNATURE POUR DOCUMENT HTML A GENERER
  {
    path: ':projectId/:documentSlug',
    component: (
      <DocumentSignatureContainerFeature
        toGenerate={true}
        fromExisting={false}
        isSignature={false}
      />
    ),
  },
  // PREPARE SIGNATURE D'UPSELL
  {
    path: ':projectId/:documentSlug/:upsellId',
    component: (
      <DocumentSignatureContainerFeature
        toGenerate={true}
        fromExisting={false}
        isSignature={false}
      />
    ),
  },
];
